import { ScrollReveal } from "@/components/ScrollReveal";
import { AccordionFAQ } from "@/components/AccordionFAQ";
import { SEO } from "@/components/SEO";
import { ROUTE_PATHS } from "@/lib/index";
import { Link } from "react-router-dom";
const faqItems = [{
  question: "À qui s'adresse cette formation B2C ?",
  answer: "Que tu sois en reconversion professionnelle et/ou que tu cherches à développer des compétences monétisables avec une structure qui fonctionne et qui a déjà fait ses preuves, alors cette formation est pour toi. Pas de promesses creuses, du vrai, de l'humain, de l'éthique."
}, {
  question: "Comment fonctionne le mécanisme de commission à 20% ?",
  answer: "Pendant la capsule Setting, lorsque tu books des rendez-vous avec des prospects, je prends en charge les appels de closing à ta place. Si je conclus la vente, tu reçois 20% du montant de la transaction. C'est une façon de rémunérer ton travail de terrain pendant que tu montes en compétences."
}, {
  question: "Pourquoi zéro roleplay dans la formation ?",
  answer: "Parce que le roleplay ne prépare pas à la réalité. Les vraies conversations ont une texture, une émotion, une imprévisibilité que les jeux de rôle ne reproduisent jamais. Ici, tu t'entraînes sur de vrais prospects dès le début, assisté par l'IA pour analyser tes messages et calibrer ton approche."
}, {
  question: "Quelle différence entre les deux formules ?",
  answer: "La formule Full Autonome te donne accès à tout le contenu de la formation pour avancer à ton rythme. La formule One-to-One y ajoute un accompagnement personnalisé : visioconférences régulières, suivi de ton CRM et de tes KPIs, feedback sur tes conversations, et travail sur ta posture et ton autorité commerciale."
}, {
  question: "En combien de temps je serai opérationnel ?",
  answer: "Grâce à la commission de 20% sur les bookings, tu peux générer des revenus dès la capsule Setting — donc potentiellement dès les premières semaines. Pour une maîtrise complète qui te permet de monétiser de façon autonome et récurrente, compte 6 mois de pratique intensive."
}, {
  question: "La formation couvre aussi l'aspect administratif ?",
  answer: "Oui, la capsule bonus couvre tout l'aspect administratif et structuration : contrats, facturation, statut légal, organisation de ton activité de setter ou closer freelance. C'est la partie que personne n'enseigne — et qui fait toute la différence entre un amateur et un professionnel."
}, {
  question: "Y a-t-il des facilités de paiement ?",
  answer: "Un paiement jusqu'en trois fois est possible."
}];
export default function FormationB2C() {
  return <>
    <SEO 
      title="Formation B2C Setting & Closing — Shut Up & Close"
      description="Formation complète en Setting et Closing B2C. Apprends à vendre sans forcer avec une méthode terrain éprouvée. Commission 20% pendant la formation."
      canonical="https://camillevega.fr/#/formation-b2c"
      type="course"
    />
    <div className="min-h-screen" style={{
    backgroundColor: '#1E130C',
    color: '#EDE8DF'
  }}>
      <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md" style={{
      backgroundColor: 'rgba(30, 19, 12, 0.85)'
    }}>
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <Link to={ROUTE_PATHS.HOME} className="text-2xl font-bold transition-opacity hover:opacity-80" style={{
          fontFamily: 'Cormorant Garamond, serif',
          color: '#E8651A'
        }}>
            Shut Up & Close
          </Link>
          <div className="hidden md:flex items-center gap-8" style={{
          fontFamily: 'Space Mono, monospace',
          fontSize: '0.75rem'
        }}>
            <Link to={ROUTE_PATHS.HOME} className="hover:opacity-70 transition-opacity">
              Accueil
            </Link>
            <a href="#programme" onClick={e => {
            e.preventDefault();
            document.getElementById('programme')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="hover:opacity-70 transition-opacity cursor-pointer">
              Programme
            </a>
            <a href="#offres" onClick={e => {
            e.preventDefault();
            document.getElementById('offres')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="hover:opacity-70 transition-opacity cursor-pointer">
              Offres
            </a>
          </div>
          <a href="https://wa.me/33695771167?text=Bonjour%20Camille%2C%20j%27ai%20d%C3%A9couvert%20ton%20site%20et%20je%20voudrais%20qu%27on%20%C3%A9change%20de%20vive%20voix.%20Quelles%20sont%20tes%20disponibilit%C3%A9s%20pour%20un%20appel%20%3F" target="_blank" rel="noopener noreferrer" className="px-6 py-2 rounded-sm font-medium transition-all hover:scale-105" style={{
          backgroundColor: '#E8651A',
          color: '#1E130C',
          fontFamily: 'Space Grotesk, sans-serif'
        }}>
            Demander un appel
          </a>
        </div>
      </nav>

      <section className="min-h-screen pt-32 pb-20 px-8">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-xs uppercase tracking-widest mb-6" style={{
            fontFamily: 'Space Mono, monospace',
            color: '#9A8878'
          }}>
              — Formation B2C · Setting & Closing · 2026
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6" style={{
            fontFamily: 'Cormorant Garamond, serif',
            lineHeight: '1.1'
          }}>
              Tu veux vendre <span style={{
              fontStyle: 'italic',
              color: '#E8651A'
            }}>sans forcer</span>.<br />On t'apprend comment.
            </h1>
            <p className="text-lg mb-8 leading-relaxed" style={{
            fontFamily: 'Space Grotesk, sans-serif',
            color: '#9A8878'
          }}>
              La vraie vente, ce n'est pas convaincre. C'est créer les conditions où ton prospect décide de lui-même — avec clarté, sans pression, sans manipulation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="https://wa.me/33695771167?text=Bonjour%20Camille%2C%20j%27ai%20d%C3%A9couvert%20ton%20site%20et%20je%20voudrais%20qu%27on%20%C3%A9change%20de%20vive%20voix.%20Quelles%20sont%20tes%20disponibilit%C3%A9s%20pour%20un%20appel%20%3F" target="_blank" rel="noopener noreferrer" className="px-8 py-4 rounded-sm font-semibold transition-all hover:scale-105" style={{
              backgroundColor: '#E8651A',
              color: '#1E130C',
              fontFamily: 'Space Grotesk, sans-serif'
            }}>
                Demander un appel
              </a>
              <a href="https://wa.me/33695771167?text=Bonjour%20Camille%2C%20j%27ai%20d%C3%A9couvert%20ton%20site%20et%20j%27aimerais%20en%20savoir%20plus%20sur%20ta%20formation.%20Peux-tu%20m%27envoyer%20plus%20d%27informations%20%3F" target="_blank" rel="noopener noreferrer" className="px-8 py-4 rounded-sm font-medium transition-all hover:bg-opacity-10" style={{
              border: '1px solid #EDE8DF',
              color: '#EDE8DF',
              fontFamily: 'Space Grotesk, sans-serif'
            }}>
                Poser une question
              </a>
            </div>
          </div>

          <div className="p-8 rounded-sm" style={{
          backgroundColor: '#2A1A10',
          border: '1px solid rgba(232, 101, 26, 0.3)'
        }}>
            <div className="text-sm uppercase tracking-widest mb-6" style={{
            fontFamily: 'Space Mono, monospace',
            color: '#E8651A'
          }}>
              // Résultats de la méthode
            </div>
            <div className="space-y-6">
              {[{
              label: 'Durée pour maîtrise complète',
              value: 100,
              display: '6 mois'
            }, {
              label: 'Commission pendant l\'apprentissage',
              value: 20,
              display: '20%'
            }, {
              label: 'Roleplay dans la formation',
              value: 0,
              display: '0'
            }, {
              label: 'Modules (Setting + Closing)',
              value: 100,
              display: '2×13'
            }].map((metric, idx) => <div key={idx}>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-sm" style={{
                  fontFamily: 'Space Grotesk, sans-serif',
                  color: '#9A8878'
                }}>
                      {metric.label}
                    </span>
                    <span className="text-lg font-bold" style={{
                  fontFamily: 'Space Mono, monospace',
                  color: '#E8651A'
                }}>
                      {metric.display}
                    </span>
                  </div>
                  <div className="h-1 rounded-full" style={{
                backgroundColor: '#321F14'
              }}>
                    <div className="h-full rounded-full transition-all duration-1000" style={{
                  width: `${metric.value}%`,
                  backgroundColor: '#E8651A'
                }} />
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-8" style={{
      backgroundColor: '#321F14'
    }}>
        <div className="max-w-7xl mx-auto">
          <ScrollReveal>
            <div className="text-xs uppercase tracking-widest mb-4" style={{
            fontFamily: 'Space Mono, monospace',
            color: '#E8651A'
          }}>
              Le constat
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{
            fontFamily: 'Cormorant Garamond, serif'
          }}>
              Tu prospectes, tu parles, tu ne closes pas.
            </h2>
            <p className="text-lg mb-12" style={{
            fontFamily: 'Space Grotesk, sans-serif',
            color: '#9A8878'
          }}>
              L'ancienne vente est morte. Les scripts standardisés, les relances agressives, les urgences fabriquées — tout ça génère du rejet, pas de la conversion. Le prospect de 2026 détecte la pression à distance et se ferme instantanément. Il ne veut pas être vendu. Il veut être compris.
            </p>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[{
            title: 'Tu parles trop tôt',
            description: "Tu pitches ton offre avant même d'avoir compris où en est ton prospect. Il se ferme — et tu ne le sens pas venir."
          }, {
            title: 'Tu cibles mal',
            description: "Tu dépenses de l'énergie sur des profils non qualifiés, sans méthode pour distinguer rapidement le bon prospect du mauvais."
          }, {
            title: 'Tu te fais ghoster',
            description: 'No-shows, "je reviens vers toi", vus sans réponse. Sans structure, tu laisses des dizaines d\'opportunités mourir en silence.'
          }, {
            title: 'Tu manques de posture',
            description: 'La vente se gagne avant l\'appel. Si ton profil, tes messages et ton cadre envoient les mauvais signaux, tu pars perdant.'
          }].map((card, idx) => <ScrollReveal key={idx} delay={idx * 0.1}>
                <div className="p-8 rounded-sm h-full transition-all hover:scale-[1.02]" style={{
              backgroundColor: '#2A1A10'
            }}>
                  <h3 className="text-xl font-bold mb-4" style={{
                fontFamily: 'Cormorant Garamond, serif'
              }}>
                    {card.title}
                  </h3>
                  <p style={{
                fontFamily: 'Space Grotesk, sans-serif',
                color: '#9A8878',
                lineHeight: '1.6'
              }}>
                    {card.description}
                  </p>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </section>

      <section className="py-20 px-8">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12">
          <div>
            <ScrollReveal>
              <div className="text-xs uppercase tracking-widest mb-4" style={{
              fontFamily: 'Space Mono, monospace',
              color: '#E8651A'
            }}>
                Principe fondateur
              </div>
              <h2 className="text-4xl font-bold mb-6" style={{
              fontFamily: 'Cormorant Garamond, serif'
            }}>
                Un setter ne défend jamais une offre.
              </h2>
              <p className="mb-4" style={{
              fontFamily: 'Space Grotesk, sans-serif',
              color: '#9A8878',
              lineHeight: '1.7'
            }}>
                Il défend la lucidité de son prospect. C'est précisément ce détachement apparent qui génère l'engagement le plus profond.
              </p>
              <p style={{
              fontFamily: 'Space Grotesk, sans-serif',
              color: '#9A8878',
              lineHeight: '1.7'
            }}>
                Shut Up & Close est une formation opérationnelle construite sur ce principe. Tu n'apprendras pas à convaincre. Tu apprendras à créer les conditions où ton prospect prend sa décision naturellement — sans manipulation, sans forcing, sans script à réciter.
              </p>
            </ScrollReveal>
          </div>

          <ScrollReveal delay={0.2}>
            <div className="p-8 rounded-sm" style={{
            backgroundColor: '#2A1A10',
            borderLeft: '4px solid #E8651A'
          }}>
              <p className="text-2xl mb-4" style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontStyle: 'italic',
              color: '#EDE8DF'
            }}>"Le closing devient une formalité, quand on maitrise l’art de la clart"</p>
              <p className="text-sm" style={{
              fontFamily: 'Space Grotesk, sans-serif',
              color: '#9A8878',
              lineHeight: '1.6'
            }}>On ne force rien, on clarifie, on analyse et on propose. Ni plus ni moins.</p>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section id="programme" className="py-20 px-8" style={{
      backgroundColor: '#321F14'
    }}>
        <div className="max-w-7xl mx-auto">
          <ScrollReveal>
            <div className="text-xs uppercase tracking-widest mb-4" style={{
            fontFamily: 'Space Mono, monospace',
            color: '#E8651A'
          }}>
              Le programme
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{
            fontFamily: 'Cormorant Garamond, serif'
          }}>
              Deux capsules. Une maîtrise complète.
            </h2>
            <p className="text-lg mb-12" style={{
            fontFamily: 'Space Grotesk, sans-serif',
            color: '#9A8878'
          }}>
              La formation est structurée en deux capsules principales de 13 modules chacune, plus une capsule bonus. Chaque module contient une vidéo explicative, un PDF de référence, des fiches outils directement applicables et des exercices d'entraînement terrain — uniquement sur de vrais prospects, assisté par l'IA. Zéro roleplay.
            </p>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <ScrollReveal delay={0.1}>
              <div className="p-8 rounded-sm" style={{
              backgroundColor: '#2A1A10'
            }}>
                <div className="text-xs uppercase tracking-widest mb-2" style={{
                fontFamily: 'Space Mono, monospace',
                color: '#E8651A'
              }}>
                  // CAPSULE 01
                </div>
                <h3 className="text-3xl font-bold mb-4" style={{
                fontFamily: 'Cormorant Garamond, serif'
              }}>
                  Setting
                </h3>
                <p className="mb-4" style={{
                fontFamily: 'Space Grotesk, sans-serif',
                color: '#9A8878',
                lineHeight: '1.6'
              }}>
                  Du premier contact à la prise de rendez-vous qualifié. Tu apprends à construire une présence crédible, créer la connexion, qualifier chirurgicalement et booker avec un taux de présence proche de 100%.
                </p>
                <div className="text-sm font-bold mb-4" style={{
                fontFamily: 'Space Mono, monospace',
                color: '#E8651A'
              }}>
                  13 modules
                </div>
                <p className="text-sm" style={{
                fontFamily: 'Space Grotesk, sans-serif',
                color: '#9A8878',
                lineHeight: '1.6'
              }}>
                  Quatre axes couverts : construction d'une posture et d'un positionnement crédibles · maîtrise de la conversation commerciale de la prise de contact jusqu'au booking · organisation et gestion des données prospects · intégration de l'IA comme outil d'analyse et de calibration au quotidien.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <div className="p-8 rounded-sm" style={{
              backgroundColor: '#2A1A10'
            }}>
                <div className="text-xs uppercase tracking-widest mb-2" style={{
                fontFamily: 'Space Mono, monospace',
                color: '#E8651A'
              }}>
                  // CAPSULE 02
                </div>
                <h3 className="text-3xl font-bold mb-4" style={{
                fontFamily: 'Cormorant Garamond, serif'
              }}>
                  Closing
                </h3>
                <p className="mb-4" style={{
                fontFamily: 'Space Grotesk, sans-serif',
                color: '#9A8878',
                lineHeight: '1.6'
              }}>
                  De l'appel qualifié à la décision. Tu apprends à structurer chaque appel, traiter les objections en profondeur, lire les profils psychologiques et conclure sans jamais forcer.
                </p>
                <div className="text-sm font-bold mb-4" style={{
                fontFamily: 'Space Mono, monospace',
                color: '#E8651A'
              }}>
                  13 modules
                </div>
                <p className="text-sm" style={{
                fontFamily: 'Space Grotesk, sans-serif',
                color: '#9A8878',
                lineHeight: '1.6'
              }}>
                  Trois axes couverts : compréhension de la psychologie d'achat et des profils comportementaux · structuration d'un appel de closing de l'ouverture à la décision · gestion de la relation post-appel pour maintenir le pipeline actif.
                </p>
              </div>
            </ScrollReveal>
          </div>

          <ScrollReveal delay={0.3}>
            <div className="p-8 rounded-sm" style={{
            backgroundColor: '#2A1A10'
          }}>
              <div className="text-xs uppercase tracking-widest mb-2" style={{
              fontFamily: 'Space Mono, monospace',
              color: '#E8651A'
            }}>
                // CAPSULE BONUS
              </div>
              <h3 className="text-3xl font-bold mb-4" style={{
              fontFamily: 'Cormorant Garamond, serif'
            }}>
                Administratif & Structuration
              </h3>
              <p style={{
              fontFamily: 'Space Grotesk, sans-serif',
              color: '#9A8878',
              lineHeight: '1.6'
            }}>
                Contrats, facturation, statut légal, organisation de ton activité de setter ou closer freelance. La partie que personne n'enseigne — et qui fait toute la différence entre un amateur et un professionnel.
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.4}>
            <div className="mt-12">
              <div className="text-xs uppercase tracking-widest mb-4" style={{
              fontFamily: 'Space Mono, monospace',
              color: '#E8651A'
            }}>
                Format pédagogique
              </div>
              <div className="grid md:grid-cols-4 gap-6">
                {[{
                title: 'Vidéo par module',
                desc: 'Chaque concept expliqué en vidéo — dense, structuré, sans remplissage. Un module = un concept maîtrisé.'
              }, {
                title: 'PDF de référence',
                desc: 'Un support structuré par module à consulter, annoter et relire à tout moment de l\'apprentissage.'
              }, {
                title: 'Fiches outils',
                desc: 'Des frameworks opérationnels à intégrer directement dans tes conversations dès le lendemain.'
              }, {
                title: 'Exercices terrain',
                desc: 'Zéro roleplay. Des missions concrètes sur de vrais prospects, calibrées et analysées par l\'IA.'
              }].map((item, idx) => <div key={idx}>
                    <h4 className="font-bold mb-2" style={{
                  fontFamily: 'Space Grotesk, sans-serif'
                }}>
                      {item.title}
                    </h4>
                    <p className="text-sm" style={{
                  fontFamily: 'Space Grotesk, sans-serif',
                  color: '#9A8878',
                  lineHeight: '1.6'
                }}>
                      {item.desc}
                    </p>
                  </div>)}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section className="py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal>
            <div className="text-xs uppercase tracking-widest mb-4" style={{
            fontFamily: 'Space Mono, monospace',
            color: '#E8651A'
          }}>
              Exclusivité B2C
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{
            fontFamily: 'Cormorant Garamond, serif'
          }}>
              Tu apprends et tu touches déjà une commission.
            </h2>
            <p className="text-lg mb-12 max-w-3xl" style={{
            fontFamily: 'Space Grotesk, sans-serif',
            color: '#9A8878'
          }}>
              Pendant la capsule Setting, si tu books des rendez-vous avec des prospects, je prends la main sur les appels de closing à ta place. Si je conclus la vente — tu touches 20% de la transaction. Tu construis ta compétence et tu génères déjà des revenus.
            </p>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <ScrollReveal delay={0.1}>
              <div className="p-8 rounded-sm" style={{
              backgroundColor: '#E8651A'
            }}>
                <div className="text-4xl font-bold mb-4" style={{
                fontFamily: 'Cormorant Garamond, serif',
                color: '#1E130C'
              }}>
                  20% de commission
                </div>
                <p style={{
                fontFamily: 'Space Grotesk, sans-serif',
                color: '#1E130C',
                lineHeight: '1.6'
              }}>
                  Pendant la capsule Setting, si tu books des rendez-vous avec des prospects, je prends la main sur les appels de closing à ta place. Si je conclus la vente — tu touches 20% de la transaction.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <div className="space-y-4">
                {[{
                num: '01',
                title: 'Tu apprends à booker',
                desc: 'Tu qualifies tes prospects et prends des rendez-vous en appliquant les modules de la capsule Setting.'
              }, {
                num: '02',
                title: 'Je prends le call de closing',
                desc: 'Tu m\'envoies le rendez-vous qualifié. Je gère l\'appel de vente à ta place — sans que tu aies à intervenir.'
              }, {
                num: '03',
                title: 'La vente se signe',
                desc: 'Si je close — tu touches 20% de la transaction. Un vrai revenu pendant ta montée en compétences.'
              }, {
                num: '04',
                title: 'Tu monétises seul(e) en 6 mois',
                desc: 'Après 6 mois de pratique intensive, tu maîtrises le Setting ET le Closing. Tu es autonome et bankable.'
              }].map((step, idx) => <div key={idx} className="p-4 rounded-sm" style={{
                backgroundColor: '#2A1A10',
                borderLeft: '2px solid #E8651A'
              }}>
                    <div className="text-xs font-bold mb-1" style={{
                  fontFamily: 'Space Mono, monospace',
                  color: '#E8651A'
                }}>
                      {step.num}
                    </div>
                    <h4 className="text-lg font-bold mb-2" style={{
                  fontFamily: 'Cormorant Garamond, serif'
                }}>
                      {step.title}
                    </h4>
                    <p className="text-sm" style={{
                  fontFamily: 'Space Grotesk, sans-serif',
                  color: '#9A8878'
                }}>
                      {step.desc}
                    </p>
                  </div>)}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <section id="offres" className="py-20 px-8" style={{
      backgroundColor: '#321F14'
    }}>
        <div className="max-w-7xl mx-auto">
          <ScrollReveal>
            <div className="text-xs uppercase tracking-widest mb-4" style={{
            fontFamily: 'Space Mono, monospace',
            color: '#E8651A'
          }}>
              Ton investissement
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{
            fontFamily: 'Cormorant Garamond, serif'
          }}>
              Deux voies. Un même résultat.
            </h2>
            <p className="text-lg mb-12" style={{
            fontFamily: 'Space Grotesk, sans-serif',
            color: '#9A8878'
          }}>
              Selon ton niveau d'autonomie et ton besoin d'accompagnement, deux formules sont disponibles. Les deux donnent accès à l'intégralité du contenu de la formation et au mécanisme de commission pendant l'apprentissage.
            </p>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-8">
            <ScrollReveal delay={0.1}>
              <div className="p-10 rounded-sm" style={{
              backgroundColor: '#2A1A10'
            }}>
                <div className="text-xs uppercase tracking-widest mb-2" style={{
                fontFamily: 'Space Mono, monospace',
                color: '#E8651A'
              }}>
                  FORMULE · E-LEARNING
                </div>
                <h3 className="text-3xl font-bold mb-4" style={{
                fontFamily: 'Cormorant Garamond, serif'
              }}>
                  Full Autonome
                </h3>
                <div className="text-5xl font-bold mb-6" style={{
                fontFamily: 'Cormorant Garamond, serif',
                color: '#E8651A'
              }}>
                  1 500€ <span style={{
                  fontSize: '1.2rem',
                  fontWeight: 'normal',
                  color: '#9A8878'
                }}>TTC</span>
                </div>
                <p className="mb-8" style={{
                fontFamily: 'Space Grotesk, sans-serif',
                color: '#9A8878',
                lineHeight: '1.6'
              }}>
                  Tu avances à ton rythme, avec un accès complet à toutes les capsules, outils et exercices. Idéal si tu es autonome et rigoureux dans ton organisation.
                </p>
                <div className="space-y-3 mb-8">
                  {['Capsules Setting + Closing — 13 modules chacune', 'Capsule bonus administrative', 'Vidéos, PDFs, fiches outils & exercices terrain', 'Outil IA d\'analyse de profils prospects', 'Commission 20% sur bookings pendant l\'apprentissage', 'Mises à jour incluses'].map((item, idx) => <div key={idx} className="flex items-start gap-3">
                      <span style={{
                    color: '#E8651A'
                  }}>✦</span>
                      <span className="text-sm" style={{
                    fontFamily: 'Space Grotesk, sans-serif',
                    color: '#EDE8DF'
                  }}>
                        {item}
                      </span>
                    </div>)}
                </div>
                <a href="https://wa.me/33695771167?text=Bonjour%20Camille%2C%20j%27ai%20d%C3%A9couvert%20ton%20site%20et%20je%20voudrais%20qu%27on%20%C3%A9change%20de%20vive%20voix.%20Quelles%20sont%20tes%20disponibilit%C3%A9s%20pour%20un%20appel%20%3F" target="_blank" rel="noopener noreferrer" className="block w-full px-8 py-4 rounded-sm font-semibold text-center transition-all hover:scale-105" style={{
                backgroundColor: '#E8651A',
                color: '#1E130C',
                fontFamily: 'Space Grotesk, sans-serif'
              }}>
                  Demander un appel
                </a>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <div className="p-10 rounded-sm relative" style={{
              backgroundColor: '#2A1A10',
              border: '2px solid #E8651A'
            }}>
                <div className="absolute top-4 right-4 px-3 py-1 text-xs uppercase tracking-wider rounded-sm" style={{
                backgroundColor: '#E8651A',
                color: '#1E130C',
                fontFamily: 'Space Mono, monospace'
              }}>
                  Recommandé
                </div>
                <div className="text-xs uppercase tracking-widest mb-2" style={{
                fontFamily: 'Space Mono, monospace',
                color: '#E8651A'
              }}>
                  FORMULE · ACCOMPAGNEMENT
                </div>
                <h3 className="text-3xl font-bold mb-4" style={{
                fontFamily: 'Cormorant Garamond, serif'
              }}>
                  One-to-One
                </h3>
                <div className="text-5xl font-bold mb-6" style={{
                fontFamily: 'Cormorant Garamond, serif',
                color: '#E8651A'
              }}>
                  2 400€ <span style={{
                  fontSize: '1.2rem',
                  fontWeight: 'normal',
                  color: '#9A8878'
                }}>TTC</span>
                </div>
                <p className="mb-8" style={{
                fontFamily: 'Space Grotesk, sans-serif',
                color: '#9A8878',
                lineHeight: '1.6'
              }}>
                  L'intégralité de la formation e-learning plus un accompagnement personnalisé pour aller plus vite, plus loin, et avec une posture irréprochable.
                </p>
                <div className="space-y-3 mb-8">
                  {['Tout ce qui est inclus dans Full Autonome', 'Visioconférences one-to-one régulières', 'Suivi de ton CRM & de tes KPIs', 'Travail sur ta posture & ton autorité commerciale', 'Feedback personnalisé sur tes conversations', 'Commission 20% sur bookings pendant l\'apprentissage'].map((item, idx) => <div key={idx} className="flex items-start gap-3">
                      <span style={{
                    color: '#E8651A'
                  }}>✦</span>
                      <span className="text-sm" style={{
                    fontFamily: 'Space Grotesk, sans-serif',
                    color: '#EDE8DF'
                  }}>
                        {item}
                      </span>
                    </div>)}
                </div>
                <a href="https://wa.me/33695771167?text=Bonjour%20Camille%2C%20j%27ai%20d%C3%A9couvert%20ton%20site%20et%20je%20voudrais%20qu%27on%20%C3%A9change%20de%20vive%20voix.%20Quelles%20sont%20tes%20disponibilit%C3%A9s%20pour%20un%20appel%20%3F" target="_blank" rel="noopener noreferrer" className="block w-full px-8 py-4 rounded-sm font-semibold text-center transition-all hover:scale-105" style={{
                backgroundColor: '#E8651A',
                color: '#1E130C',
                fontFamily: 'Space Grotesk, sans-serif'
              }}>
                  Demander un appel
                </a>
              </div>
            </ScrollReveal>
          </div>

          <div className="mt-8 text-center">
            <p className="text-sm" style={{
            fontFamily: 'Space Grotesk, sans-serif',
            color: '#9A8878',
            fontStyle: 'italic'
          }}>
              Estimation de maîtrise complète : 6 mois. Une maîtrise opérationnelle du Setting et du Closing, des compétences pleinement monétisables et une autonomie totale dans la génération de revenus.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 px-8">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal>
            <div className="text-xs uppercase tracking-widest mb-4" style={{
            fontFamily: 'Space Mono, monospace',
            color: '#E8651A'
          }}>
              Questions
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-12" style={{
            fontFamily: 'Cormorant Garamond, serif'
          }}>
              Réponses directes à vos vraies questions.
            </h2>
          </ScrollReveal>
          <AccordionFAQ items={faqItems} />
        </div>
      </section>

      <section className="py-24 px-8 text-center" style={{
      backgroundColor: '#321F14'
    }}>
        <div className="max-w-4xl mx-auto">
          <ScrollReveal>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{
            fontFamily: 'Cormorant Garamond, serif'
          }}>
              Prêt(e) à arrêter de pitcher et commencer à closer ?
            </h2>
            <p className="text-lg mb-8" style={{
            fontFamily: 'Space Grotesk, sans-serif',
            color: '#9A8878'
          }}>
              Une formation construite sur la réalité du terrain, pas sur des théories de salle de classe. Deux capsules. Un système. Une compétence qui se monétise.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="https://wa.me/33695771167?text=Bonjour%20Camille%2C%20j%27ai%20d%C3%A9couvert%20ton%20site%20et%20je%20voudrais%20qu%27on%20%C3%A9change%20de%20vive%20voix.%20Quelles%20sont%20tes%20disponibilit%C3%A9s%20pour%20un%20appel%20%3F" target="_blank" rel="noopener noreferrer" className="px-8 py-4 rounded-sm font-semibold transition-all hover:scale-105" style={{
              backgroundColor: '#E8651A',
              color: '#1E130C',
              fontFamily: 'Space Grotesk, sans-serif'
            }}>
                Demander un appel
              </a>
              <a href="https://wa.me/33695771167?text=Bonjour%20Camille%2C%20j%27ai%20d%C3%A9couvert%20ton%20site%20et%20j%27aimerais%20en%20savoir%20plus%20sur%20ta%20formation.%20Peux-tu%20m%27envoyer%20plus%20d%27informations%20%3F" target="_blank" rel="noopener noreferrer" className="px-8 py-4 rounded-sm font-medium transition-all hover:bg-opacity-10" style={{
              border: '1px solid #EDE8DF',
              color: '#EDE8DF',
              fontFamily: 'Space Grotesk, sans-serif'
            }}>
                Poser une question
              </a>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <footer className="py-12 px-8" style={{
      borderTop: '1px solid #321F14'
    }}>
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">
            <div>
              <div className="text-2xl font-bold mb-2" style={{
              fontFamily: 'Cormorant Garamond, serif',
              color: '#E8651A'
            }}>
                Shut Up & Close
              </div>
              <div className="text-sm" style={{
              fontFamily: 'Space Grotesk, sans-serif',
              color: '#9A8878'
            }}>
                Formation Setting & Closing · B2C & B2B · 2026
              </div>
            </div>
            <div className="flex gap-8" style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: '0.75rem'
          }}>
              <Link to={ROUTE_PATHS.HOME} className="hover:opacity-70 transition-opacity" style={{
              color: '#9A8878'
            }}>
                Accueil
              </Link>
              <Link to={ROUTE_PATHS.FORMATION_B2C} className="hover:opacity-70 transition-opacity" style={{
              color: '#9A8878'
            }}>
                Formation B2C
              </Link>
              <Link to={ROUTE_PATHS.FORMATION_B2B} className="hover:opacity-70 transition-opacity" style={{
              color: '#9A8878'
            }}>
                Formation B2B
              </Link>
            </div>
          </div>
          <div className="mt-8 pt-8 text-center text-sm" style={{
          borderTop: '1px solid #321F14',
          fontFamily: 'Space Grotesk, sans-serif',
          color: '#9A8878'
        }}>
            © 2026 Shut Up & Close. Tous droits réservés.
          </div>
        </div>
      </footer>
    </div>
  </>;
}